// 調證用戶詳情 - 繁體中文
export default {
  header: {
    title: "調證用戶",
    surveyReport: "調證報告",
  },
  note: {
    label: "備註：",
    empty: "暫無",
    edit: "編輯",
  },
  buttons: {
    downloadSurveyInfo: "下載調證資訊",
  },
  walletBalance: {
    title: "錢包地址總餘額",
    tooltip:
      "錢包地址總資產餘額目前暫只統計（ETHEREUM、TRON、BSC、BTC、polygon等五條鏈地址的餘額）\n\n根據本系統已收錄的幣種價值，按地址持有的所有主幣和代幣折算USDT的總餘額",
    updatePrompt: "點擊右邊按鈕更新餘額",
    update: "更新",
    partialSuccess: "（部分地址餘額更新成功）",
  },
  loading: {
    text: "拼命加載中",
  },
  statistics: {
    recharge: "充值(USDT）",
    withdrawal: "提現(USDT）",
    otcBuy: "otc買入(人民幣)",
    otcSell: "otc賣出(人民幣)",
    times: "次",
  },
  tabs: {
    userBehavior: "用戶行為",
    otcTrading: "OTC交易",
    depositWithdrawal: "充提交易",
    walletBalance: "錢包餘額",
    accountBalance: "賬戶餘額",
    loginDevice: "登入/設備資訊",
    receiveInfo: "收貨資訊",
    paymentMethod: "收款方式記錄",
    otherInfo: "其他資訊",
  },
};
